import { MoovInstanceExecutionHistoryDTO } from "../DTO/moovInstanceExecutionHistoryDTO";
import { OutputParameterValue } from "./moovStepInstance";

export class MoovInstanceExecutionHistory{
    public id!: number;
    public customerId!: number;
    public moovConfigurationId!: number;
    public configurationStatus!: number; //0=Draft, 1=Testing, 2=Active, 3=Inactive
    public sourceFileName!: string;
    public sourceFileId!: number;
    public sourceFilePurgeAfter!: Date;
    public sourceFilePurgedAt!: Date;
    public status!: number; //0=created, 1=in process, 2=completed, 3=failed, 4=deleted
    public completedAt!: Date;
    public added!: Date;
    public updated!: Date;
    public addedByUserId!: number;
    public waitingForApprovalByUserId!: number; //0=no approval expected
    public nextStepId!: number;
    public nextStep!: string;
    public nextStepDueAt!: Date;
    public currentStepsStatus!: any; //key=sequenceNo, value=status (0=scheduled, 1=in process, 2=completed, 3=failed, 4=deleted, 5=suspended)
    public metaDataOutputList!: Array<OutputParameterValue[]>;

    public static mapFromDTO(param:MoovInstanceExecutionHistoryDTO):MoovInstanceExecutionHistory{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovInstanceExecutionHistory();
        try
        {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.moovConfigurationId = param.moovConfigurationId;
            obj.configurationStatus = param.configurationStatus;
            obj.sourceFileName = param.sourceFileName;
            obj.sourceFileId = param.sourceFileId;
            if(param.sourceFilePurgeAfter) obj.sourceFilePurgeAfter = new Date(param.sourceFilePurgeAfter);
            if(param.sourceFilePurgedAt) obj.sourceFilePurgedAt = new Date(param.sourceFilePurgedAt);
            obj.status = param.status;
            if(param.completedAt) obj.completedAt = new Date(param.completedAt);
            obj.added = new Date(param.added);
            if(param.updated)obj.updated = new Date(param.updated);
            obj.addedByUserId = param.addedByUserId;
            obj.waitingForApprovalByUserId = param.waitingForApprovalByUserId;
            obj.nextStepId = param.nextStepId;
            obj.nextStep = param.nextStep;
            if(param.nextStepDueAt) obj.nextStepDueAt = new Date(param.nextStepDueAt);
            obj.currentStepsStatus = param.currentStepsStatus;
            if(param.metaDataOutputList){
                obj.metaDataOutputList=[];
                param.metaDataOutputList.forEach(mdo => {
                    let mdoArray = JSON.parse(mdo) as string[]
                    obj.metaDataOutputList.push(mdoArray.map(opv => Object.assign(new OutputParameterValue(), opv)));
                });
            }
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:MoovInstanceExecutionHistory):MoovInstanceExecutionHistoryDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovInstanceExecutionHistoryDTO();
        try
        {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.moovConfigurationId = param.moovConfigurationId;
            dto.configurationStatus = param.configurationStatus;
            dto.sourceFileName = param.sourceFileName;
            dto.sourceFileId = param.sourceFileId;
            if(param.sourceFilePurgeAfter) dto.sourceFilePurgeAfter = param.sourceFilePurgeAfter.toISOString();
            if(param.sourceFilePurgedAt) dto.sourceFilePurgedAt = param.sourceFilePurgedAt.toISOString();
            dto.status = param.status;
            if(param.completedAt) dto.completedAt = param.completedAt.toISOString();
            dto.added = param.added.toISOString();
            if(param.added) dto.added = param.added.toISOString();
            dto.addedByUserId = param.addedByUserId;
            dto.waitingForApprovalByUserId = param.waitingForApprovalByUserId;
            dto.nextStepId = param.nextStepId;
            dto.nextStep = param.nextStep;
            if(param.nextStepDueAt) dto.nextStepDueAt = param.nextStepDueAt.toISOString();
            dto.currentStepsStatus = param.currentStepsStatus;
            if(param.metaDataOutputList){
                dto.metaDataOutputList = [];
                param.metaDataOutputList.forEach(mdo => dto.metaDataOutputList.push(JSON.stringify(mdo)));
            }
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    get displayStatus(){
        switch(this.status){
            case 0:
                return "created";
            case 1:
                return "processing";
            case 2:
                return "completed";
            case 3:
                return "failed"
            case 4:
                return "deleted"
            case 5:
                return "suspended"
            default:
                return "unknown"
        }
    }

    get displayConfigurationStatus(){
        switch(this.configurationStatus){
            case 0:
                return "Draft";
            case 1:
                return "Testing";
            case 2:
                return "Active";
            case 3:
                return "Inactive";
            default:
                return "";
        }
    }

    get statusColor(){
        switch(this.status){
            case 0:
                return "black";
            case 1:
                return "blue";
            case 2:
                return "green";
            case 3:
                return "red"
            case 4:
                return "gray"
            case 5:
                return "orange"
            default:
                return "black"
        }
    }

    get statusTooltip(){
        switch(this.status){
            case 0:
                return this.nextStep;
            case 1:
                return (this.waitingForApprovalByUserId>0)?"awaiting approval":this.nextStep;
            case 2:
                return undefined;
            case 3:
                return undefined;
            case 4:
                return undefined;
            default:
                return undefined;
        }
    }

}